/**
 * Tier-based limits configuration
 *
 * Tier 0 (Free): Basic plan
 * Tier 1 (Mid): Standard plan
 * Tier 2 (High): Premium plan
 * Tier 3+ (Unlimited): No practical caps on circles or team
 */
export interface TierLimits {
  maxSubcircles: number;
  maxTeamMembers: number;
}

/** Practical "unlimited" for comparisons (team add, circle create). */
export const UNLIMITED_TIER_LIMIT = Number.MAX_SAFE_INTEGER;

export const TIER_LIMITS: Record<string, TierLimits> = {
  "0": {
    maxSubcircles: 15,
    maxTeamMembers: 10,
  },
  "1": {
    maxSubcircles: 30,
    maxTeamMembers: 30,
  },
  "2": {
    maxSubcircles: 100,
    maxTeamMembers: 60,
  },
  "3": {
    maxSubcircles: UNLIMITED_TIER_LIMIT,
    maxTeamMembers: UNLIMITED_TIER_LIMIT,
  },
  "4": {
    maxSubcircles: UNLIMITED_TIER_LIMIT,
    maxTeamMembers: UNLIMITED_TIER_LIMIT,
  },
  "5": {
    maxSubcircles: UNLIMITED_TIER_LIMIT,
    maxTeamMembers: UNLIMITED_TIER_LIMIT,
  },
};

export function isUnlimitedTierLimit(limit: number): boolean {
  return limit >= UNLIMITED_TIER_LIMIT;
}

/**
 * Get tier limits for a given tier
 * Defaults to tier 0 (Free) if tier is not found
 */
export function getTierLimits(tier: string | undefined | null): TierLimits {
  const tierKey = tier || "0";
  return TIER_LIMITS[tierKey] || TIER_LIMITS["0"];
}

/**
 * Get the maximum number of subcircles for a tier
 */
export function getMaxSubcircles(tier: string | undefined | null): number {
  return getTierLimits(tier).maxSubcircles;
}

/**
 * Get the maximum number of team members for a tier
 */
export function getMaxTeamMembers(tier: string | undefined | null): number {
  return getTierLimits(tier).maxTeamMembers;
}
